<template>
    <div class="multi-table-chart">
        <div class="row">
            <div class="offset-sm-8 col-sm-4">
                <select class="form-control" v-model="selected">
                    <option v-for="(l,key) in labels" :value="key">{{l}}</option>
                </select>
            </div>
        </div>
        <br>
        <table-chart v-for="(d,key) in data" :key="key" :data="d" :height="height" v-show="key === selected"></table-chart>
    </div>
</template>
<script>
    import TableChart from './Table';

    export default{
        data: function(){
            return {
                selected: 0
            }
        },
        props: ['data','labels','height'],
        components:{
            TableChart
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/MultiTable.vue